import {Checkbox} from '@ultradent/components';
import {Form, Formik} from 'formik';

const OptInReminderOption = ( {optIn, onChange} ) =>
    <Formik
        enableReinitialize={true}
        initialValues={{
            optInReminder: [optIn ? 'yes' : 'no']
        }}>
        <Form className="mt-4">
            <Checkbox
                name="optInReminder"
                labelClassName="inline-block"
                value="yes"
                label="Opt in for reminder emails for reordering products"
                onChange={onChange}
            />
        </Form>
    </Formik>

export default OptInReminderOption;
